import { D360_CLOUD_BASE_URL, LLM_FEATURE_TYPES } from 'shared/consts/consts';
import { WHATSAPP_PROVIDERS } from 'shared/helpers';

import { RootState } from 'store/rootReducer';

export const botRefSelector = (state: RootState) => state.Bot.data.bot_ref;

export const botPlatformRoleSelector = (state: RootState) =>
	state.User.botAdmin.data.admin_mode_access?.bot_platform_role;

export const uuidSelector = (state: RootState) => state.Bot.data.uuid;

export const configuredChannelsForBot = (state: RootState) => state.Bot.configuredChannels;

export const providerConfigured = (state: RootState) => state.Bot.data.provider_configured;

export const effectiveWhatsappProviderConfigured = (state: RootState) => {
	const providerName = state.Bot.data.common_whatsapp_provider_config?.provider_name;

	return state.Bot.data.provider_configured === WHATSAPP_PROVIDERS.common_whatsapp && providerName
		? providerName
		: state.Bot.data.provider_configured;
};

export const isLLMEntitlementEnabled = (state: RootState) =>
	[LLM_FEATURE_TYPES.BASIC, LLM_FEATURE_TYPES.ADVANCE, LLM_FEATURE_TYPES.CUSTOM].includes(
		state.Bot.configData.enable_smart_assist
	);

export const LLMFeatureName = (state: RootState) => state.Bot.configData.enable_smart_assist;

export const whatsAppClientUrlConfigured = (state: RootState) => state.Bot.data.whatsapp_client_url;

export const whatsappClientWebhookUrlSelector = (state: RootState) => state.Bot.data.wa_client_webhook_url || '';

export const isWhatsappVoiceEnabledSelector = (state: RootState) => state.Bot.data.is_whatsapp_voice_enabled;

export const allBotsList = (state: RootState) => state.BotList.data;

export const botKeyData = (state: RootState) => state.Bot.data.bot_key;

export const botNameSelector = (state: RootState) => state.Bot.data.bot_name;

export const botIconSelector = (state: RootState) => state.Bot.data.icon_url;

export const nexmoContactSelector = (state: RootState) => state.Bot.data.nexmo_contact;

export const appIdSelector = (state: RootState) => state.Bot.data.app_id;

export const whatsAppClientUrl = (state: RootState) => state.Bot.data.whatsapp_client_url;

export const isWACloudNumberSelector = (state: RootState) => state.Bot.data.whatsapp_client_url === D360_CLOUD_BASE_URL;
